module.exports = __webpack_public_path__ + "img/iconHistoryProduct.6bf4eb78.svg";